module.exports = __webpack_public_path__ + "static/img/businessInfo.d2b0f6cb.svg";